/**
 * W16 统一金额显示: $ + 千分位, 无币种码(AUD/USD 等)。
 * 实际扣款币种由 admin 侧激活币种 (stripe_currency) 决定, 显示层不区分。
 * - 总额类: fmtMoney(700) → "$700", fmtMoney(2900) → "$2,900"
 * - 单价类: fmtMoney(0.14, 2) → "$0.14"
 */
export function fmtMoney(amount, decimals = 0) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '$0';
  return '$' + n.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** 分 → 美元显示: fmtCents(70000) → "$700" */
export function fmtCents(cents, decimals = 0) {
  return fmtMoney((Number(cents) || 0) / 100, decimals);
}
